import { render, staticRenderFns } from "./MaterialOwnSourse.vue?vue&type=template&id=d2470984&scoped=true&"
import script from "./MaterialOwnSourse.vue?vue&type=script&lang=js&"
export * from "./MaterialOwnSourse.vue?vue&type=script&lang=js&"
import style0 from "./materialOwnSource.styl?vue&type=style&index=0&id=d2470984&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2470984",
  null
  
)

export default component.exports